module.exports = __webpack_public_path__ + "img/c-clients-4.jpg";